// extracted by mini-css-extract-plugin
module.exports =  {"trigger":"Drs0Esl"};